export default ({ header, content, contact }) => {
	return {
		header,
		content,
		contact,
	};
};
